export default __webpack_public_path__ + "static/media/starCircle.6a963b00.svg";